module.exports = __webpack_public_path__ + "img/drop-trak-red-450x300.f2213e19.png";